module.exports = __webpack_public_path__ + "img/TOKOPEDIA_ID.35005513.svg";